import React, { useEffect, useState } from "react";
import "./GroupView.css";
import supabase from "../../../supabaseClient";
import SocialUserCard from "../../../components/social/SocialUserCard";
import { useChatDock } from "../../../contexts/ChatDockContext";
import { useAuth } from '../../../contexts/authContext';
import { useNavigate } from "react-router-dom";

const MembersTab = ({ groupId }) => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user: currentUser } = useAuth();
  const { openChat } = useChatDock();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMembers = async () => {
      setLoading(true);
      // Fetch group members
      const { data: groupMembers, error: groupMembersError } = await supabase
        .from("group_members")
        .select("*, profiles: user_id (id, display_name, name, age, location, occupation, native_languages, target_languages, avatar_url, bio, interests)")
        .eq("group_id", groupId);
      if (groupMembersError) {
        setMembers([]);
        setLoading(false);
        return;
      }
      // Fetch group to get creator
      const { data: group, error: groupError } = await supabase
        .from("groups")
        .select("id, created_by")
        .eq("id", groupId)
        .single();
      // Prepare avatar URLs
      const membersWithRoles = await Promise.all(
        groupMembers.map(async (member) => {
          let role = member.role || "Member";
          if (group && member.user_id === group.created_by) {
            role = "Admin";
          }
          return {
            ...member.profiles,
            id: member.user_id,
            role,
            joined_at: member.joined_at,
            avatar_public_url: member.profiles?.avatar_url || null
          };
        })
      );
      const sortedMembers = [...membersWithRoles].sort((a, b) => {
        if (a.role === "Admin" && b.role !== "Admin") return -1;
        if (b.role === "Admin" && a.role !== "Admin") return 1;
        if (a.joined_at && b.joined_at) {
          return new Date(a.joined_at) - new Date(b.joined_at);
        }
        return 0;
      });
      setMembers(sortedMembers);
      setLoading(false);
    };
    if (groupId) fetchMembers();
  }, [groupId]);

  const memberCount = members.length;

  return (
    <div className="members-tab">
      <div className="members-header">
        <h2>Group Members</h2>
        {!loading && (
          <span className="members-count">
            {memberCount} member{memberCount === 1 ? "" : "s"}
          </span>
        )}
      </div>
      <div className="members-grid user-grid">
        {loading ? (
          <div>Loading members...</div>
        ) : members.length > 0 ? (
          members.map((member) => {
            const userData = {
              ...member,
              avatar_url: member.avatar_public_url || member.avatar_url || null,
            };
            const isSelf = currentUser && member.id === currentUser.id;
            const extraBadge = member.role
              ? { label: member.role, title: `Group role: ${member.role}` }
              : null;

            return (
              <SocialUserCard
                key={member.id}
                user={userData}
                isSelf={isSelf}
                canMessage={!isSelf}
                extraBadge={extraBadge}
                onClick={() => window.open(`/app/profile/${member.id}`, "_blank", "noopener,noreferrer")}
                onMessage={() => openChat(member.id)}
                showHoverDetails
              />
            );
          })
        ) : (
          <div>No members found.</div>
        )}
      </div>
    </div>
  );
};

export default MembersTab;